
const styles = (theme) => ({
  ...theme.global,
  formControl: {
    flex: 1
  }
})
export default styles
